import { LegalPage, type LegalSection } from './LegalPage';

const SECTIONS: LegalSection[] = [
  {
    heading: 'Agreement',
    body: [
      'These terms are between you and ITCity (Sylhet, Bangladesh), the operator of Possignin. By creating an account or using the service, you agree to them.',
      'If you use Possignin on behalf of a business, you confirm you are authorised to accept these terms for that business.',
    ],
  },
  {
    heading: 'The service',
    body: [
      'Possignin is a cloud point-of-sale and business management service: sales, inventory, HRM, CRM, manufacturing, repair, and reporting, available on the web and supported devices.',
      'We work to keep the service available and improving, but we provide it on an "as available" basis and may add, change, or remove features.',
    ],
  },
  {
    heading: 'Your account',
    body: [
      'Keep your login details secure; you are responsible for activity under your account. Tell us promptly if you suspect unauthorised access.',
      'You must give accurate information and keep it up to date. One person is responsible for billing on each business account.',
    ],
  },
  {
    heading: 'Acceptable use',
    body: [
      'Do not use Possignin to break the law, infringe others’ rights, send spam, or attempt to disrupt or gain unauthorised access to the service.',
      'You are responsible for the lawfulness of the data you enter, including your customers’ information.',
    ],
  },
  {
    heading: 'Subscriptions & billing',
    body: [
      'Paid plans are billed in Bangladeshi Taka (BDT). You can pay online via SSLCommerz or by cash to our Sylhet office.',
      'New businesses get a 7-day free trial. After the trial, a plan must be active to keep using the service.',
      'If a payment is missed, we will remind you. After the grace period, the business may be suspended until payment is made; your data is retained during suspension.',
    ],
  },
  {
    heading: 'Your data',
    body: [
      'You own the business data you put into Possignin. We process it to provide the service, as described in our Privacy Policy.',
      'You can export your data at any time. On account closure, we delete it within 30 days unless we must keep records by law.',
    ],
  },
  {
    heading: 'Intellectual property',
    body: [
      'Possignin, its software, and its branding belong to ITCity. These terms do not transfer any of our intellectual property to you.',
      'Resellers may use the Possignin platform under a separate reseller agreement, with their own branding as permitted there.',
    ],
  },
  {
    heading: 'Liability & law',
    body: [
      'To the extent allowed by law, our total liability for any claim is limited to the fees you paid in the three months before the claim.',
      'These terms are governed by the laws of Bangladesh, and disputes are subject to the courts of Sylhet.',
    ],
  },
  {
    heading: 'Changes',
    body: [
      'We may update these terms; the new version will be posted here with an updated date, and material changes will be notified in the app. Continuing to use Possignin means you accept the change.',
    ],
  },
];

export function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      updated="14 June 2026"
      intro="The agreement for using Possignin — written to be read, not just signed."
      sections={SECTIONS}
    />
  );
}
